import React, { useRef } from 'react';
import moment from 'moment';

import {
	TableCell,
	TableHead,
	TableRow,
	List,
	ListItem,
	ListItemText,
	ListItemSecondaryAction,
} from '@material-ui/core';
import ReactToPrint from 'react-to-print';

import { StatusBullet } from '../../../components';
import DropdownSelection from '../../Dashboard/components/LatestOrders/dropdownSelection';
import ProductListWithImage from './productListWithImage';
import PaymentInfoDialog from './paymentInfoDialog';
import { BaseButton } from 'views/UIWidgets';
import OrderToPrint from './orderToPrint';

export const OrderTableHeader = () => (
	<TableHead>
		<TableRow>
			<TableCell>基本信息</TableCell>
			<TableCell style={{ minWidth: '300px' }}>购买商品列表</TableCell>
			<TableCell style={{ minWidth: '75px' }}>总金额</TableCell>
			<TableCell style={{ minWidth: '200px' }}>配送/支付方式</TableCell>
			<TableCell>订单状态</TableCell>
			<TableCell style={{ minWidth: '100px' }}>支付状态</TableCell>
			<TableCell style={{ minWidth: '40px' }}>打印</TableCell>
		</TableRow>
	</TableHead>
);

const returnOrderStatusColor = status => {
	switch (status) {
		case '待发货':
			return 'warning';
		case '已签收':
			return 'success';
		default:
			return 'primary';
	}
};

const DeliveryView = ({ order }) => (
	<List dense={true}>
		<ListItem>
			<ListItemText primary='配送方式: ' />
			<ListItemSecondaryAction>
				{order.shippingMethod ?? 'null'}
			</ListItemSecondaryAction>
		</ListItem>
		<ListItem>
			<ListItemText primary='货到付款: ' />
			<ListItemSecondaryAction>
				{order.payOnDelivery === true ? '是' : '否'}
			</ListItemSecondaryAction>
		</ListItem>
		<ListItem>
			<ListItemText primary='包裹放前台/门口: ' />
			<ListItemSecondaryAction>
				{order.putParcelOnDoor === true ? '是' : '否'}
			</ListItemSecondaryAction>
		</ListItem>
		<ListItem>
			<ListItemText primary='配送地址: ' />
		</ListItem>
		<ListItem>{`${
			order.address
				? `${order.address.address} ${order.address.phoneNumber} ${order.address.receiver}`
				: '无配送地址'
		}`}</ListItem>
		<ListItem>
			<ListItemText primary='客户备注: ' />
		</ListItem>
		<ListItem>{`${order.remark ? order.remark : '无'}`}</ListItem>
	</List>
);

export const OrderTableRow = ({ order, updateOrderStatus }) => {
	const componentRef = useRef();

	return (
		<TableRow hover key={order._id}>
			<TableCell
				style={{
					maxWidth: '100px',
					whiteSpace: 'normal',
					wordWrap: 'break-word',
					alignItems: 'center',
				}}
			>
				<h4>用户</h4>
				<span>{order.user.internalId}</span>
				<h4
					style={{
						marginTop: 10,
					}}
				>
					订单号
				</h4>
				<span>{order._id}</span>
				<h4
					style={{
						marginTop: 10,
					}}
				>
					创建日期
				</h4>
				{moment(order.date).format('DD/MM/YYYY HH:mm')}
			</TableCell>
			<TableCell>
				<ProductListWithImage productList={order.selectedItems} />
			</TableCell>
			<TableCell>${order.totalPrice}</TableCell>
			<TableCell>
				<DeliveryView order={order} />
			</TableCell>
			<TableCell>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
					}}
				>
					<StatusBullet
						color={returnOrderStatusColor(order.status)}
						size='sm'
					/>
					<DropdownSelection
						value={order.status}
						style={{ marginLeft: 8 }}
						handleSelect={value => {
							updateOrderStatus(order._id, value, order);
						}}
					/>
				</div>
			</TableCell>
			<TableCell
				style={{
					maxWidth: '120px',
					whiteSpace: 'normal',
					wordWrap: 'break-word',
				}}
			>
				<List dense={true}>
					{order.isPaid === false ? '未网上支付' : ''}
					{order.isPaid === true ? '已网上支付' : ''}
					<div style={{ height: '10px' }} />
					{order.stripePayment && (
						<PaymentInfoDialog stripePaymentId={order.stripePayment} />
					)}
					{order.royalPayPayment && (
						<PaymentInfoDialog royalPayPayment={order.royalPayPayment} />
					)}
				</List>
			</TableCell>
			<TableCell>
				<ReactToPrint
					trigger={() => <BaseButton title='打印订单' />}
					content={() => componentRef.current}
				/>
				<div style={{ display: 'none' }}>
					<OrderToPrint ref={componentRef} order={order} />
				</div>
			</TableCell>
		</TableRow>
	);
};
